/**
 * Space stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const spaceStickersPack: ToilePack = {
    slug: 'space-stickers',
    category: 'sticker',
    name: 'Space stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'planet', label: 'Ringed planet', subject: 'a round planet with rings and a small smiling face'},
        {key: 'rocket', label: 'Rocket', subject: 'a retro rocket with fins blasting off with a puff of smoke'},
        {key: 'astrocat', label: 'Astronaut cat', subject: 'a cat in a space helmet floating with a paw raised'},
    ],
    styles: [
        {key: 'holo', label: 'Holographic', style: 'holographic sticker, iridescent rainbow sheen across the surface, glossy', palette: 'Iridescent silver shifting through pink, cyan and gold', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'vinyl', label: 'Vinyl', style: 'glossy vinyl sticker, clean vector shapes, bold flat colour, a small highlight', palette: 'Bright flat colour with a white highlight', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
    ],
    directions: ['a UFO instead', 'for a laptop lid', 'as a glow-in-the-dark version'],
    directionHint: 'try: a UFO instead',
    seo: {
        title: 'Space Stickers: Planet, Rocket, Astronaut Cat',
        metaDescription: 'Nine space stickers — a smiling ringed planet, a retro rocket, an astronaut cat — in holographic, kawaii, and vinyl styles.',
        h1: 'Space stickers: ringed planet, rocket, astronaut cat',
        tagline: 'Nine stickers, three space characters, three styles each.',
        intro: 'The sticker set for the void: a round planet with rings and a small smiling face, a retro rocket blasting off with a puff of smoke, and a cat in a space helmet floating with a paw raised. Each rendered holographic, kawaii, and glossy vinyl. Ask for a different planet, a UFO scene, or a whole solar-system composition, and the same three styles carry it.',
        useCases: [
            'a laptop or water bottle',
            'a bullet journal or planner page',
            "a kids' room decoration",
            'a phone case sticker sheet',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine space stickers — a ringed planet, a retro rocket, and an astronaut cat — in holographic, kawaii, and glossy vinyl finishes.'},
            {q: 'Can I get a different planet or scene?', a: 'Yes — the direction field takes any variation, including a different planet, a UFO scene, or a whole solar-system composition.'},
            {q: 'What does the holographic finish actually print as?', a: 'The holographic design is an illustrated iridescent sheen — print it on holographic vinyl stock to get the real shifting effect, or on plain matte stock for a flat colourful version.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
        ],
    },
}
